import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { AsphaltIcon } from '../components/icons/materials/asphalt';
import { BiosolidsIcon } from '../components/icons/materials/biosolids';
import { BrushBranchIcon } from '../components/icons/materials/brush-branch';
import { BrushLogsIcon } from '../components/icons/materials/brush-logs';
import { BrushStumpsIcon } from '../components/icons/materials/brush-stumps';
import { BulkyFurnitureIcon } from '../components/icons/materials/bulky-furniture';
import { CoarseCrushedRockIcon } from '../components/icons/materials/coarse-crushed-rock';
import { ComixIcon } from '../components/icons/materials/comix';
import { ConcreteIcon } from '../components/icons/materials/concrete';
import { ConcreteRebarIcon } from '../components/icons/materials/concrete-rebar';
import { ConstructionIcon } from '../components/icons/materials/construction';
import { CreosoteIcon } from '../components/icons/materials/creosote';
import { DirtIcon } from '../components/icons/materials/dirt';
import { DustIcon } from '../components/icons/materials/dust';
import { FineGrainCrushedRockIcon } from '../components/icons/materials/fine-grain-crushed-rock';
import { LargeCrushedRockIcon } from '../components/icons/materials/large-crushed-rock';
import { MattressIcon } from '../components/icons/materials/mattresses';
import { MediumCrushedRockIcon } from '../components/icons/materials/medium-crushed-rock';
import { MswIcon } from '../components/icons/materials/msw';
import { OtherIcon } from '../components/icons/materials/other';
import { RoofingIcon } from '../components/icons/materials/roofing';
import { SandIcon } from '../components/icons/materials/sand';
import { ScrapMetalIcon } from '../components/icons/materials/scrap';
import { SingleStreamIcon } from '../components/icons/materials/single-stream';
import { TiresIcon } from '../components/icons/materials/tires';
export const iconsForMaterial = {
    bulky13: _jsx(BulkyFurnitureIcon, {}),
    cND: _jsx(ConstructionIcon, {}),
    roofing: _jsx(RoofingIcon, {}),
    asbestos: _jsx(OtherIcon, {}),
    asphalt: _jsx(AsphaltIcon, {}),
    asbestosNonFriable: _jsx(OtherIcon, {}),
    bNB: _jsx(BrushBranchIcon, {}),
    bNL: _jsx(BrushLogsIcon, {}),
    bNS: _jsx(BrushStumpsIcon, {}),
    cardboard: _jsx(SingleStreamIcon, {}),
    concrete: _jsx(ConcreteIcon, {}),
    comix: _jsx(ComixIcon, {}),
    compost: _jsx(OtherIcon, {}), //TODO: Add compost icon
    concreteRebar: _jsx(ConcreteRebarIcon, {}),
    creosote: _jsx(CreosoteIcon, {}),
    dirt: _jsx(DirtIcon, {}),
    sand: _jsx(SandIcon, {}),
    msw: _jsx(MswIcon, {}),
    scrap: _jsx(ScrapMetalIcon, {}),
    singleStream: _jsx(SingleStreamIcon, {}),
    CLAY_ROOFING: _jsx(RoofingIcon, {}),
    commingle: _jsx(SingleStreamIcon, {}),
    WOOD_ROOFING: _jsx(RoofingIcon, {}),
    foodWaste: _jsx(OtherIcon, {}),
    mattresses: _jsx(MattressIcon, {}),
    SLATE_ROOFING: _jsx(RoofingIcon, {}),
    CONCRETE_ROOFING: _jsx(RoofingIcon, {}),
    tires: _jsx(TiresIcon, {}),
    transportation: _jsx(OtherIcon, {}),
    dryIndustrialWaste: _jsx(OtherIcon, {}),
    concreteWashout: _jsx(_Fragment, {}),
    bioSolids: _jsx(BiosolidsIcon, {}),
    dust: _jsx(DustIcon, {}),
    fineGrainCrushedRock: _jsx(FineGrainCrushedRockIcon, {}),
    coarseCrushedRock: _jsx(CoarseCrushedRockIcon, {}),
    mediumCrushedRock: _jsx(MediumCrushedRockIcon, {}),
    largeCrushedRock: _jsx(LargeCrushedRockIcon, {}),
    other: _jsx(OtherIcon, {}),
};
//# sourceMappingURL=icons-for-materials.js.map